import api from '@/modules/api'
import { mutationNames } from '@/store/storeKey'
const state = {
  Facebook: {
    'Id': 0,
    'PageTitle': '',
    'FacebookId': '',
    'FacebookToken': '',
    'SubscriptionModuleActivation_Id': 0,
    'HeaderElements': '',
    'FbPageTitle': '',
    'flag': 0,
    'FooterElements': ''
  }
}
const getters = {
  Facebook: state => state.Facebook
}
const mutations = {
  [mutationNames.SET_FACEBOOK_PARENT] (state, Parent) {
    state.Facebook = Parent
  },
  [mutationNames.UPDATE_FACEBOOK] (state, obj) {
    Object.assign(state.Facebook, obj)
  }
}
const actions = {
  updateFacebookSettings ({ commit, getters }, payload) {
    commit(mutationNames.UPDATE_FACEBOOK, payload)
  },
  async getFacebookModule ({ commit, getters }, SubscriptionModuleId) {
    const response = await api.AppModules.GetFacebookInfo(SubscriptionModuleId)
    commit(mutationNames.SET_FACEBOOK_PARENT, response[0])
    return response[0]
  },
  async GetFacebookPageInfo ({ commit, getters }, payload) {
    const response = await api.AppModules.getFacebookPageInfo(payload)
    return response
  },
  async UrlValidChk ({ commit, getters }, WebsiteUrl) {
    const response = await api.AppModules.WebsiteUrlValid(WebsiteUrl)
    return response
  },
  async saveFacebookSettings ({ dispatch, getters }) {
    let FacebookClone = Object.assign({}, getters.Facebook)
    await api.AppModules.SaveFacebookInfo(FacebookClone)
  }

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/appModules/facebook.js